import { render, staticRenderFns } from "./CardTypeForm.vue?vue&type=template&id=273f23c4"
import script from "./CardTypeForm.vue?vue&type=script&lang=js"
export * from "./CardTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports